import { createContext, useContext, useState, useCallback, useMemo } from 'react'
export const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])

  const add = useCallback((message, type = 'info') => {
    const id = Date.now()
    const newNotif = { id, message, type }
    setNotifications(prev => [...prev, newNotif])

    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id))
    }, 4000)
  }, [])

  const value = useMemo(() => ({ notifications, add }), [notifications, add])

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}

// HOOK TO USE IN COMPONENTS
export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider')
  }
  return context
}